export const TiposPartidas = [
  "Sin clasificar",
  "Mano de obra",
  "Maquinaria y medios auxiliares",
  "Materiales",
  "Componentes adicionales de residuo",
  "Clasificación de residuo",
]
